import React, { useEffect, useState } from 'react'
import Cardbanner from '../MyComponent/CardBanner'
import { useParams } from 'react-router-dom';
import Seo from '../MyComponent/Seo';
import { EditorialIntro, EditorialSections } from '../MyComponent/EditorialContent';
import { categoryContent } from '../content/siteContent';
import fallbackBanner from '../images/ready-banner.png';

function QuotesSayings() {
  const { url } = useParams()
  const [category, setCategory] = useState(null)
  const [products, setProducts] = useState([])
  const [status, setStatus] = useState('loading')
  const pageContent = categoryContent[url]

  const fetchCategory = async () => {
    setStatus('loading')
    try {
      const response = await fetch('/api/category/fetch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filter: { url } })
      })
      const data = await response.json()
      if (data.success && data.categories[0]) {
        setCategory(data.categories[0])
      } else {
        setCategory(null)
        setStatus('error')
      }
    } catch (error) {
      console.error('Error fetching category:', error)
      setCategory(null)
      setStatus('error')
    }
  }
  const fetchProducts = async () => {
    try {
      const response = await fetch('/api/product/fetch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filter: { categories: category._id } })
      })
      const data = await response.json()
      if (data.success) {
        setProducts(data.products)
        setStatus('ready')
      } else {
        setProducts([])
        setStatus('error')
      }
    } catch (error) {
      console.error('Error fetching products:', error)
      setProducts([])
      setStatus('error')
    }
  }

  useEffect(() => {
    setCategory(null)
    setProducts([])
    fetchCategory();
    // The request is keyed by the route slug.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  useEffect(() => {
    if (category) fetchProducts();
    // Products are reloaded whenever a new category resolves.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  const background = {
    // backgroundImage: `url(${require('../images/readybanner1.jpg')})`,
    backgroundImage: `url(${category?.banner || fallbackBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '420px',
    width: '100%',
    color: '#fff',
  };
  const heading = pageContent?.heading || category?.title || 'Photographic Letter Art';
  const intro = pageContent?.intro || category?.description || 'Explore photographic letters arranged into meaningful artwork for your home.';
  const productsHeading = pageContent?.productsHeading || 'Available Designs';

  return (
    <main className="category-page">
      {pageContent && <Seo {...pageContent} />}
      <section className='Ready-made-Words category-photo-hero' style={background} aria-label={`${heading} collection`}>
        <span className="category-hero-label">Craig Photo Letters Collection</span>
      </section>
      <EditorialIntro heading={heading} intro={intro} eyebrow="Shop the collection" />
      <section className="collection-products" aria-labelledby="collection-products-heading">
        <div className="editorial-shell">
          <h2 id="collection-products-heading">{productsHeading}</h2>
          {status === 'loading' && <p className="collection-status" role="status">Loading the collection…</p>}
          {status === 'error' && <p className="collection-status" role="alert">We couldn’t load the collection right now. Please refresh the page or try again shortly.</p>}
          {status === 'ready' && products.length === 0 && <p className="collection-status">New designs are coming soon. In the meantime, create a custom piece of your own.</p>}
        </div>
        {products.length > 0 && <Cardbanner products={products} />}
      </section>
      {pageContent && <EditorialSections sections={pageContent.sections} ariaLabel={`About ${heading}`} />}
    </main>
  )
}

export default QuotesSayings
